import React from 'react'

export default () => (
  <svg
    width={'27'}
    height={'21'}
    viewBox="0 0 27 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#454545" fill="none" fillRule="evenodd">
      <path d="M17.074 4.6l2.78-2.776c1.1-1.1 2.884-1.1 3.985 0l1.228 1.228c1.1 1.1 1.1 2.88 0 3.98l-7.762 7.752c-1.1 1.1-2.885 1.1-3.986 0l-1.228-1.228c-1.1-1.1-1.1-2.88 0-3.98" />
      <path d="M9.82 16.35l-2.78 2.776c-1.1 1.1-2.885 1.1-3.986 0L1.824 17.9c-1.1-1.1-1.1-2.883 0-3.982l7.763-7.752c1.1-1.1 2.885-1.1 3.986 0l1.23 1.228c1.1 1.1 1.1 2.88 0 3.98" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/linkIcon.js